export default __webpack_public_path__ + "static/Axiel-90e6f58c633f9bd3f3bd3ed08466ecc6.png";